import { URL_SURVEY_API } from '../utils/constEnvVariables';
import { CRS_SURVEY_CODES, SURVEY_CODE_MAP_PATH } from '../utils/surveyLiterals';
import { CRS_EXT_TOKEN } from '../utils/constants';

export async function requestExternalAccess(email, param) {
    const requestOptions = {
        method: 'POST',
        redirect: 'manual',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
            "email": email, "param": param
        })
    }

    return await fetch(`${URL_SURVEY_API}/surveys-ext/auth/otp/request`, requestOptions)
        .then(response => {
            if (!response.ok) {
                return response.json().then(data => {
                    throw new Error(data.message || 'Failed to send OTP. Please try again.');
                });
            }
            if (response.status === 204) {
                throw new Error('Request not available. Please contact your administrator.');
            }
            return response.json();
        })            
        .catch(error => {
            throw new Error(error.message || 'Failed to connect with the OTP service. Please try again.');
        });
}

export async function verifyAccessOtp(email, otp, param) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
            "email": email, "otp": otp, "param": param
        })
    }

    return await fetch(`${URL_SURVEY_API}/surveys-ext/auth/otp/verify`, requestOptions)
        .then(async response => {
            if (!response.ok) {
                return response.json().then(data => {
                    throw new Error(data.message || 'Failed to verify OTP. Please try again.');
                });
            }
            const tmpResponse = await response.json();      
            const tmpPathName = tmpResponse.code === CRS_SURVEY_CODES.CM ? SURVEY_CODE_MAP_PATH.get(tmpResponse.code) : tmpResponse.templateContextPath;      
            
            const state = {
                pathname: `/${tmpPathName}ext`,
                previous: '/surveyLogin',
                surveyType: tmpResponse.description,
                supplierName: `${tmpResponse.supplierNumber} - ${tmpResponse.supplierName ? tmpResponse.supplierName : "Supplier"}`,
                queryParam: tmpResponse.id,
                surveyCode: tmpResponse.code,
                isAuthNonOkta: true,
                endDate: tmpResponse.endDate,
                updatedByName: tmpResponse.assignmentUpdateDetails.updatedBy,
                updatedTs: tmpResponse.assignmentUpdateDetails.lastUpdatedTs,
                token: tmpResponse.accessToken,
                assignmentUpdateDetails: tmpResponse.assignmentUpdateDetails
            };
            
            return state;
        })            
        .catch(error => {
            throw new Error(error.message || 'Failed to verify OTP. Please try again.');
        });
}

export async function renewToken(param){
    const token = sessionStorage.getItem(CRS_EXT_TOKEN);
    if(!token){
        window.location.href = `/surveyLogin?rn=${param}`;
        return;
    }
    const requestOptions = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ 
            "param": param
        })
    }

    return await fetch(`${URL_SURVEY_API}/surveys-ext/auth/token/renew`, requestOptions)
        .then(async response => {
            if (!response.ok) {
                console.log("Token renewal failed with status: ", response.status , ' - ', response.message);
                
                if(response.status === 401){
                    window.location.href = `/surveyLogin?rn=${param}`;
                    return;
                }                
                throw new Error(response.message || 'Failed to renew token. Please try again.');
            }
            const data = await response.json();
            sessionStorage.setItem(CRS_EXT_TOKEN, data.token);
        })            
        .catch(error => {
            throw new Error(error.message || 'Failed to renew token. Please try again.');
    });    
}